module.exports = __webpack_public_path__ + "static/media/zahaib.df7687c6.jpeg";